
import React, { useEffect, useState } from 'react';
import SliderImage from '../../../../component/Global/SliderImage/index';
import { useProductStore } from 'src/hooks/product';
import { isArray } from "underscore";
import FadeInOut from "../../../../component/Global/FadeInOut";
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';

const ProductDetailImageEnlarge = (props) => {
    const { translation:t } = System;
    const [{ product_images_data }, { }, { }] = useProductStore();
    const [sliderImageData, setSliderImageData] = useState([])

    useEffect(() => {
        if (product_images_data?.VariantAssets && isArray(product_images_data.VariantAssets) &&
            product_images_data.VariantAssets.length > 0) {
            let imagesData = [];
            product_images_data.VariantAssets.map((v, i) => {
                let imageObj = {};
                imageObj.image = v.AssetURL;
                imageObj.text = v.Title;
                imageObj.publishedDate = Helper.convertDateFormatToMMDDYYYY(v.DatePublished)

                imagesData.push(imageObj)
            });
            setSliderImageData(imagesData)
        }
    }, [product_images_data])

    return (
        <>
            {sliderImageData && sliderImageData.length > 0 &&
                <FadeInOut show={true} duration={500} className={'col-xl-auto col-lg-6 col-md-6 col-4'}>
                    <div className="product-detail-gallery">
                        <span className="text-sm text-black mb-1 d-none d-md-block">
                            <i className="fa fa-arrows-alt me-1" />
                            {t('imageEnlarge')}
                        </span>

                        <SliderImage
                            data={sliderImageData}
                            showDescription={false}
                            direction="right"
                        />

                    </div>
                </FadeInOut>
            }
        </>
    );
}

export default ProductDetailImageEnlarge;